<template>
  <div class="list-item">
    <div v-show="loading" style="min-height:466px;padding: 50% 0px;"><!-- LOAD -->
      <Stretch>Carregando...</Stretch>
    </div>
    <div v-show="loading == false">
      <div class="col-lg-3">
        <card :leilao="leilao" :dados="dados" :liberado="liberado" :automatico="automatico"
              :usuarioid="usuarioid"></card>
      </div>
      <div class="col-lg-9">
        <div>
          <h2 class="product-name title-desc">
            <router-link @click.native="loteClicado"
                         :to="`/leilao/index/leilao_id/${dados.leilao_id}/lote/${dados.lote_id}`" class="open-lote"
                         v-html="dados.nm_titulo"></router-link>
          </h2>
          <!-- VISITAS E INCREMENTO -->
          <div class="container-visita-incremento text-right">
                        <span title="Número de visitas" class="display-block">
                            {{ dados.nu_visitas }}&nbsp;
                            <i aria-hidden="true" class="fa fa-eye"></i>
                        </span>
            <!--  <span title="Incremento" class="display-block">
                 R$ {{ dados.raw_incremento }}&nbsp;
                 <i aria-hidden="true" class="fa fa-plus"></i>
             </span> -->
          </div>
          <div v-if="status ? status.toLowerCase().indexOf('trt') !== -1 : false">
            <div class="product-des">
              <p v-html="dados.nm_descricao"></p>
            </div>
          </div>
          <div class="row" v-else>
            <div
              :class="(embedTransmissao && exibirvideo) ? 'product-des col-lg-6' : 'product-des col-lg-12'">
              <p style="max-height: 468px;padding: 4px !important;" v-html="dados.nm_descricao"></p>
            </div>
            <div class="col-lg-6" v-if="embedTransmissao && exibirvideo">
              <div class="col-lg-12 col-md-12" style="margin-top: 15px;">
                <iframe
                  height="250px"
                  width="100%"
                  :src="embedTransmissao"
                  :sandbox="tipoTransmissao === 'externa' ? 'allow-scripts allow-same-origin allow-presentation' : null"
                  title="Transmissão ao vivo"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; fullscreen; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        <div v-if="status ? status.toLowerCase().indexOf('trt') !== -1 : false">
          <div v-show="dados.judicial && Object.keys(dados.judicial).length > 0" class="info-judiciais row">
            <div v-for="(vistoria, idv) in dados.vistoria" :key="idv">
              <!-- Imovel, exibir endereço do bem -->
              <div v-if="vistoria.imovel_id > 0">
                <div style="margin-left: 15px; margin-bottom:10px; ">
                  <p><strong>Endereço: </strong> {{ vistoria.i_nm_endereco }}, {{ vistoria.i_nm_bairro }},
                    {{ vistoria.i_nm_cidade }} / {{ vistoria.i_nm_estado }}. </p>
                </div>
              </div>
              <!-- Outras vistorias, exibir endereço da filial -->
              <div v-else-if="vistoria.equipamento_id > 0">
                <div style="margin-left: 15px; margin-bottom:10px; ">
                  <p><strong>Endereço: </strong> {{ vistoria.e_nm_localexposicao }} </p>
                </div>
              </div>
              <div v-else-if="vistoria.veiculo_id > 0">
                <div style="margin-left: 15px; margin-bottom:10px; ">
                  <p><strong>Endereço: </strong> {{ vistoria.v_nm_localexposicao }} </p>
                </div>
              </div>
            </div>
            <div>
              <div class="col-lg-4 col-md-4">
                <p><strong>Processo: </strong><span class="display-block">{{
                    infoJudicial(dados.judicial.nu_processo)
                  }}</span></p>
                <p><strong>Exequente: </strong><span class="display-block">{{
                    infoJudicial(dados.judicial.nm_exequente)
                  }}</span></p>
                <p><strong>Executado: </strong><span class="display-block">{{
                    infoJudicial(dados.judicial.nm_executada)
                  }}</span></p>
                <p><strong>Edital: </strong><span class="display-block">{{
                    infoJudicial(dados.judicial.nm_edital)
                  }}</span></p>
                <p><strong>Avaliação: </strong><span class="display-block">{{
                    infoJudicial(dados.vl_avaliacaoleiloeiro)
                  }}</span></p>
              </div>
              <div class="col-lg-4 col-md-4">
                <p><strong>Hora Leilão: </strong><span
                  class="display-block">{{ infoJudicial(dados.judicial.nm_horaleilao) }}</span></p>
                <p><strong>Vara: </strong><span class="display-block">{{ infoJudicial(dados.judicial.nm_vara) }}</span>
                </p>
                <p><strong>D.O.E: </strong><span class="display-block">{{ infoJudicial(dados.judicial.nm_doe) }}</span>
                </p>
                <p v-if="dados.judicial.nm_praca"><strong>Leilão: </strong><span
                  class="display-block">{{ infoJudicial(dados.judicial.nm_praca) }}</span></p>
                <p v-if="dados.judicial.nm_municipio"><strong>Município: </strong><span
                  class="display-block">{{ infoJudicial(dados.judicial.nm_municipio) }}</span></p>
                <p><strong>Publicação: </strong><span
                  class="display-block">{{ infoJudicial(dados.judicial.nm_publicacao) }}</span></p>
              </div>
              <div class="col-lg-4 col-md-4">
                <div class="ultimos-lances" v-if="dados.historico_lances">
                  <!-- ULTIMOS LANCES AINDA NAO DEFINIDO NO BACKEND -->
                  <h2>Ultimos lances</h2>
                  <table class="table-lances">
                    <tr>
                      <th>Usuário</th>
                      <th>Lance</th>
                    </tr>
                    <tbody>
                    <tr v-for="(lance,idx) in dados.historico_lances.slice(0, 5)" :key="idx">
                      <td class="nm-usuario-limit" :title="lance.nm_usuario">{{ lance.nm_usuario }}</td>
                      <td style="text-align: right;">{{ formatarPreco(lance.vl) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import Card from '@/components/shared/Card'
import Carousel from '@/components/customCarousel/Carousel'
import Slide from '@/components/customCarousel/Slide'
import {Stretch, Circle6} from 'vue-loading-spinner'
import seguirLeiloeiro from "./SeguirLeiloeiro.vue";

export default {
  name: 'Item',
  computed: {
    seguirLeiloeiro() {
      return seguirLeiloeiro
    }
  },
  data() {
    return {
      errors: [],
      loading: false,
      pathName: location.protocol + "//" + window.HOSTNAME,
      widthCarousel: 235,
    }
  },
  components: {
    Carousel,
    Stretch,
    Circle6,
    Slide,
    Card
  },
  props: ['leilao', 'dados', 'liberado', 'automatico', 'usuarioid', 'status', "exibirvideo", "embedTransmissao", "tipoTransmissao"],
  methods: {
    infoJudicial(dadoJudicial) { // IF DE DADO JUDICIAL OU 'NÃO INFORMADO'
      return dadoJudicial ? dadoJudicial : 'Não informado'
    },
    formatarPreco(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}
</script>
<style scoped>
.container-visita-incremento {
  position: absolute;
  right: 15px;
  top: 0px;
  color: #6f6f6f;
}

.new-faixa {
  padding: 2px 6px;
  border-radius: 3px;
  color: #fff;
  font-weight: 600;
}

#portotemplate .product-actions a.addtocart {
  font-size: 23px;
  height: auto;
  line-height: normal;
  padding: 5px 9px;
  bottom: -100px;
}

.product-des {
  padding: 6px;
}

.product-des p {
  min-height: 100px;
  max-height: 152px;
  overflow: auto;
  display: block;
  width: 100%;
}

.product-des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

.product-des p::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}

.product-des p::-webkit-scrollbar-thumb {
  background-color: #6d6d6d;
  border: 2px solid #6d6d6d;
}

.new {
  color: #716f6f;
}

.maior-lance {
  background: #ebe267d1;
  padding: 1px 29px;
  position: absolute;
  bottom: -41px;
  width: 100%;
  left: 0;
}

.product-details-area {
  position: relative;
}

.envia-lance-label {
  position: absolute;
  color: #393939;
  width: 120px;
  right: -113px;
  bottom: -3px;
  font-size: 13px !important;
}

.product-actions {
  position: absolute;
  bottom: 0;
}

#portotemplate .product.product-list .product-actions a.addtocart {
  background: #67302b !important;
  border-color: #67302b !important;
  color: #fff !important;
}

#portotemplate .product .product-quickview,
#portotemplate .product:hover .product-actions a.addtocart {
  background: #508047 !important;
  border-color: #51764b !important;
  color: #fff !important;
}

.add-favorito {
  top: 10px;
  right: 10px;
}

#portotemplate .product .product-image-area {
  min-height: 253px;
}

.info-judiciais {
  min-height: 200px;
}

.info-judiciais strong {
  font-size: 13px;
}

.info-judiciais span {
  font-size: 12px;
  color: #9e9e9e;
}

.list-item {
  padding: 16px 0;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
}

.ultimos-lances .table-lances {
  width: 100%;
}

.ultimos-lances {
  background: #e2e2e2;
  padding: 4px;
  border-radius: 7px;
}

.ultimos-lances h2 {
  text-align: center;
  padding-top: 5px;
}

.ultimos-lances .table-lances th {
  text-align: center !important;
  background: #b7b7b7cc;
}

.ultimos-lances .table-lances td {
  text-align: left;
  padding: 4px;
}

.ultimos-lances .table-lances tr:nth-child(odd) {
  background: #fff;
}

.ultimos-lances .table-lances tr:nth-child(even) {
  background: #f2f2f2;
}

.nm-usuario-limit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 12ch;
  position: absolute;
}

@media (max-width: 900px) {
  .product-des p {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .product-name.title-desc {
    margin-top: 50px !important;
  }

  .container-visita-incremento {
    top: -33px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Item.vue